// removed by extract-text-webpack-plugin
module.exports = {"due-container":"DueAmount__due-container","dueContainer":"DueAmount__due-container","due-content":"DueAmount__due-content","dueContent":"DueAmount__due-content","due-price":"DueAmount__due-price","duePrice":"DueAmount__due-price"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/ExpressView/DueAmount/DueAmount.scss
// module id = 2264
// module chunks = 8